import { DefaultTimestampStore, TimestampStore } from './timestampStore';

const LAST_SEEN_ONLINE_STORAGE_KEY = '@witboost/autologout:lastSeenOnline';

function getStore(): TimestampStore {
  return new DefaultTimestampStore(LAST_SEEN_ONLINE_STORAGE_KEY);
}

export default getStore;
